export default [
  {
    id: "statistic",
    title: "Statistics",
    navLink: "/statistic",
  },
  {
    id: "profile-leaderboard",
    title: "Profile",
    navLink: "/profile",
  },
  {
    id: "armoury-leaderboard",
    title: "Trava Armoury",
    navLink: "/trava-armoury",
  },
  {
    id: "knight-leaderboard",
    title: "Trava Knight",
    navLink: "/trava-knight",
  },
  {
    id: "farming-leaderboard",
    title: "Farming",
    navLink: "/farming",
  },
];
